import { render } from "./AdminGastronomy.vue?vue&type=template&id=e568b5f0&scoped=true"
import script from "./AdminGastronomy.vue?vue&type=script&lang=js"
export * from "./AdminGastronomy.vue?vue&type=script&lang=js"

import "./AdminGastronomy.vue?vue&type=style&index=0&id=e568b5f0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e568b5f0"]])

export default __exports__